"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nexus = void 0;
const context_1 = require("./context");
const nexus_object_1 = require("./nexus-object");
class Nexus {
    static getContext(gl) {
        if (!gl.isTexture) {
            throw "Error while getting the context";
        }
        // find context that matches the gl.
        const context = Nexus.contexts.find(g => g.gl === gl);
        // if context is found, return it
        if (context) {
            return context;
        }
        // creating new context, it should execute only once
        const newContext = new context_1.Context(gl);
        Nexus.contexts.push(newContext);
        return newContext;
    }
    // noinspection JSUnusedGlobalSymbols
    static beginFrame(gl, fps) {
        this.getContext(gl).beginFrame(fps);
    }
    // noinspection JSUnusedGlobalSymbols
    static endFrame(gl) {
        this.getContext(gl).endFrame();
    }
    static createObject(url, renderer, render, onLoad, tokenProvider, material) {
        return new nexus_object_1.NexusObject(url, renderer, render, onLoad, tokenProvider, material);
    }
}
exports.Nexus = Nexus;
Nexus.contexts = [];
Nexus.meshcoder = "";
